import React from 'react';
import '../../styles/infosite/header.css';

const Header = () => {
  return (
    <header className="header">
      <nav className="navbar">
        <h1 className="logo">Multi Crop</h1>
        <ul className="nav-links">
          <li><a href="/howto">Help</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
